var app = angular.module('navigation.frameNavTop', []);

    require('./directives/framenavtop.directive.js');
    require('./stylesheet/header.scss');
     require('./stylesheet/header_log.scss');

module.exports = 'navigation.frameNavTop';


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/frameHeader/index.js
 ** module id = 249
 ** module chunks = 1
 **/